import  { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../../config";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useParams } from "react-router-dom";

const SingleCampingDetails = () => {
  const { cid } = useParams();
  const [tableData, setTableData] = useState({
    Email: [],
    PushNotification: [],
    WhatsApp: [],
    SMS: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch table data for each channel
  useEffect(() => {
    const fetchAllTables = async () => {
      if (!cid) {
        setError("No Campaign ID provided");
        setLoading(false);
        return;
      }

      const token = localStorage.getItem("authToken");
      if (!token) {
        setError("Authentication token not found");
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const channels = {
          Email: "email",
          PushNotification: "push",
          WhatsApp: "whatsapp",
          SMS: "sms",
        };

        const responses = await Promise.all(
          Object.entries(channels).map(async ([key, endpoint]) => {
            try {
              const res = await axios.get(
                `${API_URL}settings/templateBulkCampaign/${endpoint}?cid=${cid}&orderBy=created_on&limit=100&offset=0`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                    accept: "*/*",
                  },
                  timeout: 30000,
                }
              );
              if (res.data && res.data.status && Array.isArray(res.data.data)) {
                return [key, res.data.data];
              }
            } catch (e) {
              console.error(`Error fetching ${key} data:`, e);
            }
            return [key, []];
          })
        );

        const allData = Object.fromEntries(responses);
        setTableData(allData);
      } catch (e) {
        console.error("Error fetching campaign tables:", e);
        setError("Failed to fetch campaign data.");
      } finally {
        setLoading(false);
      }
    };

    fetchAllTables();
  }, [cid]);

  if (loading) {
    return (
      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          marginTop: "50px",
          textAlign: "center",
          padding: "2rem",
          backgroundColor: "white",
          borderRadius: "8px",
          border: "1px solid #e0e0e0",
        }}
      >
        <h3 style={{ color: "#dc3545" }}>Error Loading Campaign Data</h3>
        <p>{error}</p>
      </div>
    );
  }

  if (!cid) {
    return (
      <div
        style={{
          marginTop: "50px",
          textAlign: "center",
          padding: "2rem",
          backgroundColor: "white",
          borderRadius: "8px",
          border: "1px solid #e0e0e0",
        }}
      >
        <h3 style={{ color: "#dc3545" }}>No Campaign ID Provided</h3>
        <p>Please check the URL and try again.</p>
      </div>
    );
  }

  // Reusable Table UI
  const renderTable = (title, data) => (
    <div
      className="panel panel-default with-rounded-corner with-shadow mt-4"
      style={{
        backgroundColor: "white",
        padding: "1.5rem",
        borderRadius: "8px",
        border: "1px solid #e0e0e0",
        marginTop: "2rem",
      }}
    >
      <h4
        style={{
          color: "#293241",
          marginBottom: "1rem",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          fontWeight: "bold",
        }}
      >
        {title} Table
      </h4>
      <div className="table-responsive">
        <table className="table table-condensed table-bordered bg-white">
          <thead>
            <tr>
              <th>Recipient</th>
              <th>Status</th>
              <th>Created On</th>
              <th>Message</th>
              <th>Message ID</th>
            </tr>
          </thead>
          <tbody>
            {data && data.length > 0 ? (
              data.map((item, index) => (
                <tr key={index}>
                  <td>{item.recipient || "N/A"}</td>
                  <td>{item.status || "N/A"}</td>
                  <td>{item.created_on || "N/A"}</td>
                  <td>{item.message || "N/A"}</td>
                  <td>{item.messageid || "N/A"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No records found for {title}.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div style={{ marginTop: "50px" }}>
      {renderTable("Email", tableData.Email)}
      {renderTable("Push Notification", tableData.PushNotification)}
      {renderTable("WhatsApp", tableData.WhatsApp)}
      {renderTable("SMS", tableData.SMS)}
    </div>
  );
};

export default SingleCampingDetails;
